import { FIXING_TIME } from 'src/app/product-capture/model/consts/fixing-time.const';
import { TableCols } from '../interfaces/static-data';
import { Validators } from '@angular/forms';

export const UNDERLYING_ASSETS: TableCols[] = [
  {
    key: 'assetId',
    displayValue: 'Asset ID',
    validators: [Validators.required],
  },
  {
    key: 'assetIdType',
    displayValue: 'Asset ID Type',
    validators: [Validators.required],
  },
  {
    key: 'longName',
    displayValue: 'Long Name',
    validators: [Validators.required],
  },
  {
    key: 'type',
    displayValue: 'Type',
    validators: [Validators.required],
  },
  {
    key: 'currency',
    displayValue: 'Currency',
    type: 'select',
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'exchange',
    displayValue: 'Exchange',
  },
  {
    key: 'equityType',
    displayValue: 'Equity Type',
  },
  {
    key: 'settlementLag',
    displayValue: 'Settlement Lag',
  },
  {
    key: 'publishingLag',
    displayValue: 'Publishing Lag',
  },
  {
    key: 'rollConvention',
    displayValue: 'Roll Convention',
  },
  {
    key: 'dayCount',
    displayValue: 'Day Count',
  },
  {
    key: 'tenor',
    displayValue: 'Tenor',
  },
  {
    key: 'advisor',
    displayValue: 'Advisor',
  },
  {
    key: 'sourcePage',
    displayValue: 'Source Page',
  },
  {
    key: 'fixingTime',
    displayValue: 'Fixing Time',
    type: 'select',
    items: FIXING_TIME,
  },
  {
    key: 'customIndex',
    displayValue: 'Custom Index',
    defaultValue: false,
  },
  {
    key: 'referenceIndex',
    displayValue: 'Reference Index',
    defaultValue: false,
  },
  {
    key: 'priceIndex',
    displayValue: 'Price Index',
    defaultValue: false,
  },
  {
    key: 'multiExchange',
    displayValue: 'Multi Exchange',
    defaultValue: false,
  },
  {
    key: 'indexSponsor',
    displayValue: 'Index Sponsor',
  },
  {
    key: 'indexRulesURL',
    displayValue: 'Index Rules URL',
  },
  {
    key: 'benchmarkEUStatus',
    displayValue: 'Benchmark EU Status',
    type: 'select',
  },
  {
    key: 'benchmarkUKStatus',
    displayValue: 'Benchmark UK Status',
    type: 'select',
  },
  {
    key: 'benchmarkAdministrator',
    displayValue: 'Benchmark Administrator',
  },
  {
    key: 'website',
    displayValue: 'Website',
  },
  {
    key: 'tradingCalendars',
    displayValue: 'Trading Calendar',
    type: 'select',
    selectOptions: {
      multiple: true,
      checkbox: true,
    },
  },
  {
    key: 'denomination',
    displayValue: 'denomination',
  },
  {
    key: 'usDividend',
    displayValue: 'US Dividend',
    type: "boolean"
  },
  {
    key: 'description',
    displayValue: 'Description'
  },
  {
    key: 'strategyDetails',
    displayValue: 'Strategy Details'
  },
  {
    key: 'isPreciousMetal',
    displayValue: 'Is Precious Metal',
    type: "boolean"
  },
  {
    key: 'hasRollingFees',
    displayValue: 'Has Rolling Fees',
    type: "boolean"
  },
  {
    key: 'rollingFees',
    displayValue: 'Rolling Fees',
    type: "number"
  },
  {
    key: 'rollTriggerRemainingDays',
    displayValue: 'Roll Trigger Remaining Days',
    type: "number"
  },
  {
    key: 'contractExpiry',
    displayValue: 'Contract Expiry',
    type: 'select',
  },
  {
    key: 'followUpFutureMinDays',
    displayValue: 'Follow Up Future Minimum Days',
    type: "number"
  },
  {
    key: 'contractExpiryDates',
    displayValue: 'Expiry Dates'
  },
  {
    key: 'workflowStatus',
    displayValue: 'Workflow Status',
    hideOnForm: true
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  },
  {
    key: 'deletedAt',
    displayValue: 'Deleted On',
    hideOnForm: true
  }
];

export const UNDERLYING_ASSET_TYPES = [
  {
    id: 'BOND',
    displayValue: 'Bond',
  },
  {
    id: 'COMMODITY',
    displayValue: 'Commodity',
  },
  {
    id: 'COMMODITY_FUTURE',
    displayValue: 'Commodity Future',
  },
  {
    id: 'ETF',
    displayValue: 'ETF',
  },
  {
    id: 'FX',
    displayValue: 'FX',
  },
  {
    id: 'INDEX',
    displayValue: 'Index',
  },
  {
    id: 'INDEX_FUTURE',
    displayValue: 'Index Future',
  },
  {
    id: 'RATE',
    displayValue: 'Rate',
  },
  {
    id: 'STOCK',
    displayValue: 'Stock',
  },
];

export const UNDERLYING_ASSET_ID_TYPES = [
  {
    id: 'BLMB',
    displayValue: 'BLMB',
  },
  {
    id: 'DC',
    displayValue: 'DC',
  },
];

export const EQUITY_TYPES = [
  {
    id: 'ADR',
    displayValue: 'ADR',
  },
  {
    id: 'GDR',
    displayValue: 'GDR',
  },
  {
    id: 'ORDINARY_SHARE',
    displayValue: 'Ordinary Share',
  },
  {
    id: 'PREFERENCE_SHARE',
    displayValue: 'Preference Share',
  },
  {
    id: 'LIMITED_PARTNERSHIP',
    displayValue: 'Limited Partnership',
  },
  {
    id: 'REIT',
    displayValue: 'REIT',
  },
  {
    id: 'OTHER_SHARE',
    displayValue: 'Other Share',
  },
  {
    id: 'OTHER_DEPOSITORY_RECEIPT',
    displayValue: 'Other Depository Receipt',
  },
  {
    id: 'STAPLED_SHARES',
    displayValue: 'Stapled Shares',
  },
];

export const BENCHMARK_STATUSES = [
  {
    id: 'REGISTERED',
    displayValue: 'Registered',
  },
  {
    id: 'UNREGISTERED',
    displayValue: 'Unregistered',
  },
];

export const EXPIRY_DATES_CODE_MAPPING = {
  '1': 'F',
  '2': 'G',
  '3': 'H',
  '4': 'J',
  '5': 'K',
  '6': 'M',
  '7': 'N',
  '8': 'Q',
  '9': 'U',
  '10': 'V',
  '11': 'X',
  '12': 'Z',
}
